import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/compressed/el.webp")